// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3r8hT","itemTitle":"ClientEmergencyInfo_itemTitle__1B2UH","itemText":"ClientEmergencyInfo_itemText__2vq7x"};